export default __webpack_public_path__ + "static/media/hall_of_fame_bar_3.608997e3.png";